module.exports = __webpack_public_path__ + "static/media/light-r-2.491ae95d.png";